import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import scrollReveal from './plugins/scrollReveal'
import siteLoader from './plugins/siteLoader'
import './assets/scss/bootstrap.scss';
import './assets/css/main.css';

createApp(App)
  .use(store)
  .use(router)
  .use(scrollReveal, { router })
  .use(siteLoader, { router, store })
  .mount('#app')

document.getElementById('app-boot-splash')?.remove()
